module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oKygUI/tc-custom/9781459204607.jpg?1740460603335",
      "alt": "This image is the cover for the book Unexpected Husband, Wedlocked!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unexpected Husband, Wedlocked!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lydia had been thrilled by her temporary assignment on an Australian cattle station—until she came face-to-face with Joe Jordan on her first day! Tough, sexy Joe: the man Lydia’s impulsive sister had planned to seduce…"), _c('br'), _c('br'), _vm._v("Only, Joe made it clear that it was "), _c('i', [_vm._v("Lydia")]), _vm._v(", not her sister, who intrigued him. And he wanted to do more than work with her—he wanted to marry her! Joe’s passion overwhelmed and excited Lydia, but did he just want a convenient wife?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lindsay Armstrong\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lindsay Armstrong was born in South Africa. She grew up with three ambitions: to become a writer, to travel the world, and to be a game ranger. She managed two out of three! When Lindsay went to work it was in travel and this started her on the road to seeing the world. It wasn't until her youngest child started school that Lindsay sat down at the kitchen table determined to tackle her other ambition — to stop dreaming about writing and do it! She hasn't stopped since.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0